<ng-container *ngIf="item; else skeleton">
  <div class="winner-unit" [class.has-hover-move]="hasHover" (click)="openBetDetailsDialog(item)">
    <div class="pic" [style.padding-top]="100 / ratio + '%'">
      <div class="pic-wrap">
        <app-lazy-image [lazy]="item.webLogo || defaultImg()"></app-lazy-image>
      </div>
    </div>
    <div class="wrap">
      <div class="item">
        @if (item.playerName) {
          <app-user-avatar [avatarImgSrc]="item.avatar | avatarDefault" [currentVipLevel]="item.vip" [size]="'tiny'" />
        } @else {
          <i class="fi-incognito-filled"></i>
        }
        <span class="name">{{ item.playerName || ('invisible' | translate) }}</span>
      </div>
      <div class="item">
        <img class="currency-img" [src]="item.currency | currencyIcon" lazy="loading" alt="" />
        <cs-currency-converter class="amount" [amount]="item.payAmount" [currency]="item.currency" />
        @if (isFiatDisplay) {
          <cs-currency-unit-display class="amount" [style.marginLeft.px]="1" [currency]="item.currency" />
        }
      </div>
    </div>
  </div>
</ng-container>
<ng-template #skeleton>
  <div class="item-box skeleton-loading" [style.padding-top]="100 / ratio + '%'"></div>
</ng-template>
